<template>
  <div :class="bindClass" v-show="uidValidator.isError && !!errrText">
    <MBIcon
      v-if="uidValidator.showIcon"
      name="icon-warn"
      :size="iconSize"
      color="red"
    />
    <p ref="ErrrRef" :style="pStyle">
      {{ errrText }}
    </p>
  </div>
</template>

<script>
  import MBIcon from '@/components/MBIcon'
  import { mapState, mapGetters } from 'vuex'
  export default {
    data() {
      return {}
    },
    components: {
      MBIcon,
    },
    computed: {
      ...mapState(['gameName', 'isDesktop']),
      ...mapState('detail', ['uidValidator', 'isRenderCheckffuid']),
      ...mapGetters(['isRuStarMaker']),
      iconSize() {
        return this.isDesktop ? 16 : 33
      },
      bindClass() {
        const defaultClass = ['errr-text']
        let classTypes = []

        if (this.isDesktop) {
          classTypes.push(`${defaultClass[0]}-desktop`)
        } else {
          classTypes.push(`${defaultClass[0]}-mobile`)
        }
        return defaultClass.concat(classTypes)
      },
      pStyle() {
        return this.uidValidator.showIcon ? '' : 'padding-left: 0'
      },
      errrText() {
        if (this.uidValidator.customTips) {
          const errorMsg = this.$t(this.uidValidator.customTips)
          if (errorMsg) {
            return errorMsg
          }
        }
        const errMsg = this.$te(`${this.gameName}.uid_check_errorText`)
          ? this.$t(`${this.gameName}.uid_check_errorText`)
          : ''

        if (this.isRuStarMaker) {
          return this.$t(`publicDetails.uid_check_errorText`, {
            uid: 'SID',
          })
        }

        if (this.uidValidator.errorCode !== 200) {
          const isCode = this.$te(`apiErrorTips.${this.uidValidator.errorCode}`)
            ? this.$t(`${this.gameName}.uid_check_errorText`)
            : ''
          return isCode
            ? this.$t(`apiErrorTips.${this.uidValidator.errorCode}`)
            : errMsg
        }
        if (this.isRenderCheckffuid) {
          return this.$t(`publicDetails.repeat_uid_error`, {
            uid: 'UID',
          })
        }
        return errMsg
      },
    },
    watch: {},
    methods: {},
  }
</script>

<style scoped lang="scss" src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles.scss';
  }
</style>
